import { Injectable } from '@angular/core';
import { SecureApi } from '../core/secure.api';

@Injectable()
export class ClinicSelfReportConfigService {
    constructor(public secureApi: SecureApi) {
    }

    getByClinic(clinicId){
        return this.secureApi.get('templates/clinic/' + clinicId);
    }

    getSRConfigByClinic(clinicId, searchTerms){
        searchTerms = searchTerms.replace(/\&/gi, '%26');
        return this.secureApi.get('patient-questionnaire-custom-clinic/' + clinicId + '?search=' + searchTerms);
    }

    updateSRConfigForClinic(clinicId, sr, searchTerms = ''){
        searchTerms = searchTerms.replace(/\&/gi, '%26');
        let body = {
            'selected' : sr.selected,
            'id'       : sr.id
        };
        return this.secureApi.post('patient-questionnaire-custom-clinic/' + clinicId + '?search=' + searchTerms, body, false);
    }

    updateDefaultSRForClinic(clinicId, sr, searchTerms = ''){
        searchTerms = searchTerms.replace(/\&/gi, '%26');
        let body = {
            'id'       : sr.id,
            'is_default': sr.is_default
        };
        return this.secureApi.post('patient-questionnaire-custom-clinic/' + clinicId + '/default?search=' + searchTerms, body, false);
    }
}
